import { Injectable, inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ColloquialAttributes } from '@shared/models/icommons.model';
import { Observable } from 'rxjs';
import { UserColloquialService } from './user-colloquial.service';

/**
 * Functional resolver to pull the stream for colloquial attributes while entering the records module.
 * Any subsequent call will return the pre-existing stream kept in memory.
 */
export const colloquialResolverService: ResolveFn<Observable<ColloquialAttributes>> = () => {
  return inject(UserColloquialService).getUserColloquial();
};

/**
 * @deprecated class kept for backward compatibility — use `colloquialResolverService` instead
 *
 * Service used to pull the stream for colloquial attributes while entering to records module
 * any subsequent call will return the pre-existing stream kept in memory
 */
@Injectable({
  providedIn: 'root',
})
export class ColloquialResolverService {
  resolve = colloquialResolverService;
}
